// extracted by mini-css-extract-plugin
export default {"card":"OfficeRamCard_card__B9G9Y"};